import { useEffect } from "react";
import { useLang } from "./i18n";

const SITE = "https://ioannistsiros.com";

export const SEO_META = {
  home: {
    el: {
      path: "/",
      title: "Ιωάννης Τσίρος — Ψυχολόγος & Ψυχοθεραπεία Online",
      description:
        "Ατομική ψυχοθεραπεία online με τον Ιωάννη Τσίρο, αδειούχο ψυχολόγο MSc, εγγεγραμμένο μέλος BACP. Δωρεάν πρώτη γνωριμία — με ασφάλεια και εμπιστευτικότητα.",
    },
    en: {
      path: "/",
      title: "Ioannis Tsiros — Psychotherapist & Psychologist Online",
      description:
        "Warm, unhurried individual psychotherapy online with Ioannis Tsiros, MSc psychotherapist and BACP registered member. Free first introduction call.",
    },
  },
  about: {
    el: {
      path: "/about",
      title: "Για εμένα | Ιωάννης Τσίρος — Ψυχολόγος",
      description:
        "Γνωρίστε τον Ιωάννη Τσίρο: αδειούχο ψυχολόγο (MSc Counseling and Psychotherapy), εγγεγραμμένο μέλος BACP με εμπειρία σε ιδιωτικό γραφείο, νοσοκομεία και κλινικές.",
    },
    en: {
      path: "/about",
      title: "About | Ioannis Tsiros — Psychotherapist",
      description:
        "About Ioannis Tsiros — MSc psychotherapist, BACP registered member, licensed psychologist in Greece and the UK. Experience across private practice and clinics.",
    },
  },
  services: {
    el: {
      path: "/services",
      title: "Υπηρεσίες & Εξειδικεύσεις | Ιωάννης Τσίρος",
      description:
        "Ατομική ψυχοθεραπεία online για άγχος, καταθλιπτική διάθεση, σχέσεις, επαγγελματική εξουθένωση, πένθος και αυτοεκτίμηση — συνεδρίες 50 λεπτών, εβδομαδιαία.",
    },
    en: {
      path: "/services",
      title: "Services & Specialisations | Ioannis Tsiros",
      description:
        "Individual online psychotherapy for anxiety, low mood, relationships, burnout, grief and self-esteem — weekly 50-minute sessions at an unhurried pace.",
    },
  },
  faq: {
    el: {
      path: "/faq",
      title: "Συχνές Ερωτήσεις | Ιωάννης Τσίρος — Ψυχοθεραπεία",
      description:
        "Πρακτικές πληροφορίες για τη θεραπεία: διάρκεια και συχνότητα συνεδριών, εμπιστευτικότητα, ακυρώσεις και πώς ξεκινάμε με μια δωρεάν γνωριμία 15 λεπτών.",
    },
    en: {
      path: "/faq",
      title: "FAQ & Practical Info | Ioannis Tsiros",
      description:
        "Practical answers about therapy: session length and frequency, confidentiality, cancellations, and how to start with a free 15-minute introductory call.",
    },
  },
  intake: {
    el: {
      path: "/intake",
      title: "Κλείστε Ραντεβού | Ιωάννης Τσίρος — Ψυχοθεραπεία",
      description:
        "Στείλτε ασφαλές αίτημα προ-συμβουλευτικής γνωριμίας. Εμπιστευτικά, online, χωρίς δέσμευση — θα επικοινωνήσω για να κανονίσουμε την πρώτη σας συνεδρία.",
    },
    en: {
      path: "/intake",
      title: "Book a Consultation | Ioannis Tsiros",
      description:
        "Send a secure pre-consultation enquiry. Confidential and online, with no commitment — I will get back to you to arrange your first session.",
    },
  },
};

export const useSeo = (key, override) => {
  const { lang } = useLang();

  useEffect(() => {
    let m = null;
    if (override) {
      m = override[lang] || null;
    } else {
      m = SEO_META[key] && SEO_META[key][lang];
    }
    if (!m) return;

    document.title = m.title;

    const setMeta = (attr, name, content) => {
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", m.description);
    setMeta("property", "og:title", m.title);
    setMeta("property", "og:description", m.description);
    setMeta("property", "og:url", SITE + m.path);
    setMeta("name", "twitter:title", m.title);
    setMeta("name", "twitter:description", m.description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", SITE + m.path);
  }, [key, lang]);
};
